/**
 * The blood-drop marker that every reference-range bar draws as a Highcharts
 * data label.
 *
 * The width/height attributes here are load-bearing, not decoration. These
 * labels are `useHTML: true`, so Highcharts positions them by measuring the
 * rendered element's box and then CACHES that measurement on the label. An
 * <img> with no declared dimensions measures 0x0 until its bitmap has been
 * decoded, so when a chart renders before the drop image is decoded,
 * `verticalAlign: 'middle'` centers a zero-height box on the bar and the drop
 * settles ~6px lower — visibly hanging off the bottom of the bar. Nothing
 * corrects it afterwards: the cached box survives later re-renders (including
 * the delayed setState in ReferenceRangeChart), so the drop stays low for the
 * life of the page and is baked into any PDF exported from it.
 *
 * Whether a given page load hits it is a race against image decoding, which is
 * why it appears and disappears with browser-cache state rather than reliably.
 * Declaring the intrinsic size (the PNGs are 15x20) makes the first measurement
 * correct whether or not the bitmap has arrived, which removes the race.
 */
export const BLOOD_DROP_WIDTH = 15;
export const BLOOD_DROP_HEIGHT = 20;

export function bloodDropLabel(src: string): string {
    return `<img src="${src}" width="${BLOOD_DROP_WIDTH}" height="${BLOOD_DROP_HEIGHT}" />`;
}
